import { IntegrationClient } from "@fitness-app/data-models/entities/ProductsSettings";

import calendlyIcon from "./assets/calendly.svg";
import notionIcon from "./assets/notion-logo-1.svg";

interface IntegrationOption {
  value: IntegrationClient;
  disabled?: boolean;
  icon?: string;
  hidden?: boolean;
}

export const integrationOptions: IntegrationOption[] = [
  {
    value: IntegrationClient.Notion,
    hidden: true,
    icon: notionIcon,
  },
  {
    value: IntegrationClient.Calendly,
    hidden: false,
    icon: calendlyIcon,
  },
];
